var _styled;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { MEDIA_QUERIES } from '@govuk-react/constants'; // Label to be linked to checkbox in parent component
// in order to provide toggle function of mobile menu
// when javascript is not present.

var Button = styled('label')((_styled = {
  display: 'flex',
  alignItems: 'center'
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  display: 'none'
}, _styled));
var ButtonText = styled('div')({
  cursor: 'default',
  ':hover': {
    textDecoration: 'underline'
  }
});
var ButtonIcon = styled('div')(function (_ref) {
  var open = _ref.open;
  return {
    content: '""',
    display: 'inline-block',
    width: '0',
    height: '0',
    borderStyle: 'solid',
    borderColor: 'transparent',
    clipPath: open ? 'polygon(50% 0%, 0% 100%, 100% 100%)' : 'polygon(0% 0%, 50% 100%, 100% 0%)',
    borderWidth: open ? '0 5px 8.66px 5px' : '8.66px 5px 0 5px',
    marginLeft: '5px',
    borderTopColor: 'inherit',
    borderBottomColor: 'inherit'
  };
});

var MenuButton = function MenuButton(_ref2) {
  var title = _ref2.title,
      open = _ref2.open,
      onClick = _ref2.onClick;
  return React.createElement(Button, {
    onClick: onClick,
    htmlFor: "govuk-react-menu-button"
  }, React.createElement(ButtonText, null, title), React.createElement(ButtonIcon, {
    open: open
  }));
};

MenuButton.defaultProps = {
  title: 'Menu',
  open: false,
  onClick: function onClick() {}
};
export default MenuButton;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/top-nav/es/atoms/menu-button/index.js
// module id = 302
// module chunks = 0